// in src/comments.js
import React from 'react';
import { hasWriteAccess } from '../../../helper/resourceHelper'
import { EditButton, ReferenceField, TextField, useTranslate, useListContext, TopToolbar, usePermissions, required } from 'react-admin';
import { Table, useTheme, Grid, TableBody, Typography, CardContent, Card, Avatar, Tooltip, ButtonBase, Box } from '@mui/material'
import { CardDetailRow } from '../../../ui/Common';
import { RootOrganizationIcon } from '..';
import { useNavigate } from 'react-router-dom';




const RootOrganizationCardContent = ({ rootOrganization }) => {
    const translate = useTranslate();
    const theme = useTheme();

    return (
        <Box sx={{
            width: "100%",
            padding: "0px 12px 0px 12px",
        }}>
            <Table sx={{
                width: "100%",
            }}>
                <TableBody sx={{
                    margin: "0px",
                }}>

                    {rootOrganization.app_title && (
                        <CardDetailRow label={translate('resources.root_organization.app_title')} ValueComponent={() => <TextField source="app_title" record={rootOrganization} />} />
                    )}
                    {rootOrganization.company_url && (
                        <CardDetailRow label={translate('resources.root_organization.company_url')} ValueComponent={() => <TextField source="company_url" record={rootOrganization} />} />
                    )}

                </TableBody>
            </Table>
        </Box>
    );
}


const RootOrganizationCardHeader = ({ permissions, rootOrganization }) => {
    const translate = useTranslate();
    const theme = useTheme();

    return (


        <Box sx={{
            padding: "24px 24px 8px 24px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"

        }}>
            <Box sx={{
                margin: "0px 0px 20px 0px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
                <Box >
                    {rootOrganization.connect_favicon_logo && rootOrganization.connect_favicon_logo.src ? (
                        <img
                            style={{ width: "50px", height: "50px", backgroundColor: "transparent", borderRadius: "10px", margin: "0px", padding: "0px" }}
                            alt={rootOrganization.name ? rootOrganization.name : null}
                            src={rootOrganization.connect_favicon_logo.src}
                        />
                    ) :
                        <Avatar
                            size={"45px"}
                            style={{ backgroundColor: theme.palette.background.default, width: "45px", height: "45px" }}
                        >
                            <RootOrganizationIcon />
                        </Avatar>
                    }
                </Box>
                <Box sx={{
                    width: "24px",
                    height: "24px",
                }}>

                </Box>
            </Box>
            <Box sx={{ margin: "0px", }}>
                <Typography sx={{ textAlign: 'start', fontWeight: 700, fontSize: "20px", lineHeight: "28px" }}>{rootOrganization ? `${rootOrganization.name}` : ""}</Typography>
            </Box>
        </Box>

    );
}

const MobileGrid = () => {

    const { data, isLoading } = useListContext();
    const theme = useTheme();
    const permissionsHook = usePermissions();
    const isLoadingPermissions = permissionsHook.isLoading;
    const permissions = permissionsHook.permissions;
    const translate = useTranslate();
    const navigate = useNavigate()


    if (isLoading || (data?.length <= 0)) return null;


    return (
        <Grid
            container
            spacing={0}
            sx={{
                margin: '0px',
                width: "100%",
                backgroundColor: theme.palette.background.default,
            }}
        >
            {data && data.map((ro, index) => (
                <Grid item sm={12} md={3} sx={{ width: "100%", padding: "0px 0px 8px 0px" }} >
                    <Card key={index}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            borderRadius: "12px",
                            flexDirection: 'column',
                            margin: '0px',
                            padding: "0px"
                        }}>
                        <CardContent sx={{
                            ...theme.typography.body1,
                            width: "100%",
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: "space-between",
                            padding: "0px"
                        }}>
                            <Tooltip title={translate(`resources.root_organizations.browse_root_organization`)} disableInteractive >
                                <ButtonBase
                                    onClick={() => { if (hasWriteAccess(permissions)) { navigate(`/root_organizations/${ro.root_organization_id}`); } }}
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        margin: '0px',
                                        padding: "0px"
                                    }}
                                >
                                    <RootOrganizationCardHeader rootOrganization={ro} permissions={permissions} />
                                    <RootOrganizationCardContent sx={{
                                        width: "100%",
                                    }} rootOrganization={ro} />

                                </ButtonBase>

                            </Tooltip>
                        </CardContent>
                    </Card>

                </Grid>
            ))
            }
        </Grid >
    )


}




export default MobileGrid